<div class="app-airdrop-leaderboard">
    <div class="top-section">
        <div class="section-heading">
            Top Moon Holders
        </div>
    </div>

    <div class="top-liquidity-members">
        <div class="loader" *ngIf="loading">
            <cf-loader></cf-loader>
        </div>
        <table *ngIf="topPerformers.length > 0">
            <thead>
                <tr>
                    <th>Rank</th>
                    <th>Email Address</th>
                    <th>Name</th>
                    <th>Moons</th>
                </tr>
            </thead>
            <tbody *ngIf="topPerformers.length > 0">
                <tr *ngFor="let user of topPerformers; let i = index">
                    <td>
                        {{ user.rank + 1 }} <sup>{{ getRankSuffix(user.rank + 1) }}</sup>
                        <i class="fa-solid fa-trophy-star rank-trophy" *ngIf="user.rank === 0" style="color: gold"></i>
                        <i class="fa-solid fa-trophy-star rank-trophy" *ngIf="user.rank === 1"
                            style="color: silver"></i>
                        <i class="fa-solid fa-trophy-star rank-trophy" *ngIf="user.rank === 2"
                            style="color: yellow"></i>
                    </td>
                    <td>{{ user.email }}</td>
                    <td>
                        <img class="user-profile-image" [src]="user.profile_picture" alt="User Image" />
                        {{ user.display_name }}
                    </td>
                    <td>{{ user.moons | number:'0.0-0' }} moons</td>
                </tr>
            </tbody>
            <tbody *ngIf="topPerformers.length === 0" class="no-data-tbody">
                <tr>
                    <td colspan="4">
                        <div class="no-data-td">No data available</div>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="4">
                        <cf-paginator [page]="page + 1" [count]="total_count" [limit]="limit"
                            (changed)="pageChanged($event)">
                        </cf-paginator>
                    </td>
                </tr>
        </table>
    </div>
</div>